(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/widget-area/assets/javascripts/load-area.js') >= 0) return;  svs.modules.push('/components/core/widget-area/assets/javascripts/load-area.js');

'use strict';

var _excluded = ["fetchDataUrl"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function loadArea(area, className, finalCallback) {
  if (finalCallback === undefined) {
    finalCallback = className;
    className = undefined;
  }
  var widgets = svs.widgets.data[area];
  if (widgets) {
    var widgetsToLoad = widgets
    .filter(function (widget) {
      return widget.data && widget.data.fetchDataUrl;
    })
    .map(function (widget) {
      var d = $.Deferred();
      var widgetName = widget.widget;
      var widgetComponent = svs.widget[widgetName];
      if (widgetComponent && widgetComponent.fetchData) {
        var _widget$data = widget.data,
          url = _widget$data.fetchDataUrl,
          data = _objectWithoutProperties(_widget$data, _excluded);
        widgetComponent.fetchData({
          area: area,
          url: url
        }, data, function (err, completeData) {
          if (completeData) {
            widget.data = completeData;
            widget.partial = "widget-".concat(widgetName, "-").concat(Object.keys(widgetComponent.templates)[0]);
          }
          d.resolve();
        });
      } else {
        d.resolve();
      }
      return d;
    });

    $.when.apply(this, widgetsToLoad).then(function () {
      var templateString = Handlebars.helpers.widgetArea({
        hash: {
          name: area,
          class: className
        }
      });
      finalCallback(templateString);
    }, function () {
      finalCallback(); 
    });
  } else {
    finalCallback();
  }
}
svs.core.widget_area.loadArea = loadArea;

 })(window);